import axios from 'axios';
import { Notification, Message } from 'element-ui';
import { getToken, setToken } from '@/util/auth';

// Create axios instance
const service = axios.create({
    // baseURL: 'https://app.treeoflife.international/api/',
    baseURL: "https://api.skuuni.org/api/",
    //baseURL: 'http://127.0.0.1:8000/api/',
    timeout: 120000, // Request timeout,
    headers: {
        'Accepted': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
});

// Request intercepter
service.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            // config.headers['Authorization'] = 'Bearer ' + getToken(); // Set JWT token
            config.headers['Authorization'] = getToken();
        }
        return config;
    },
    error => {
        // Do something with request error
        Promise.reject(error);
    }
);

// response pre-processing
service.interceptors.response.use(
    response => {
        // if (response.headers.authorization) {
        //   setToken(response.headers.authorization);
        //   response.data.token = response.headers.authorization;
        // }

        return response;
    },
    error => {
        let message = error.response.statusText;
        let statusCode = error.response.status;
        let title = "Error";

        if (error.response.data && error.response.data.error) {
            message = error.response.data.error.message;
            statusCode = error.response.status;
            title = error.response.statusText;
        }

        if (statusCode === 401) {
            Message.closeAll();
            Message({
                title: title,
                message: "Unauthenticated",
                type: 'error',
                duration: 5000,
            });
            localStorage.removeItem('isLoggedIn');
        }

        // if(statusCode !== 422 && statusCode !== 429){
        //   Notification.closeAll();
        //   Notification({
        //     title: title,
        //     message: message,
        //     type: 'error',
        //     duration: 4000,
        //   });
        // }
        return Promise.reject(error);
    },
);

export default service;
